import React from "react";
import { useNavigate } from "react-router-dom";

const PopularCategory = ({ dropdownCategories = [], loading }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    navigate(`/product/${categoryId}`);
  };



  return (
    <div className="content-innerPopular">

      <section className=" overflow-hidden">
        <div className="container">

          <div className=" row justify-content-md-between align-items-center  mt-4">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <div
                className="section-head style-1 m-b30  wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="left-content">
                  <h2 className="title">Popular  categories</h2>

                </div>
              </div>
            </div>

          </div>



          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : dropdownCategories.length === 0 ? (
            <div className="text-center py-5">
              <div className="nodata">Popular categories available</div>

            </div>
          ) : (
            <div className="row gx-xl-4 g-3">
              {dropdownCategories
                .filter((cat) => cat.isPopular === true)
                .map((cat) => (

                  <div
                    key={cat._id}   // ✅ KEY MUST BE HERE
                    className="col-lg-4 col-xl-3 col-md-6 col-sm-12 relative mobilecard"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCategoryClick(cat._id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="SP_card">
                      <div className="SP_image_wrapper2 CateGAmin">
                        <img
                          className="SP_frame_image"
                          src={`${process.env.REACT_APP_API_URL}/uploads/${cat.image}`}
                          alt={cat.name}
                          width="40"
                          height="40"
                        />
                        <a className="share-btn" href="#" onClick={(e) => e.preventDefault()} />
                      </div>

                      <div
                        className="SP_customize_button2"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCategoryClick(cat._id);
                        }}
                      >
                       
                        <span className="d-md-block">{cat.name}</span>
                      </div>
                    </div>
                  </div>
                ))}

            </div>
          )}
        </div>
      </section>

    </div>
  );
};

export default PopularCategory;